import {
  GET_DEPRECIATION,
  GET_DEPRECIATION_SUCCESS,
  GET_DEPRECIATION_FAIL,
  DELETE_DEPRECIATION,
  DELETE_DEPRECIATION_SUCCESS,
  DELETE_DEPRECIATION_FAIL,
  UPDATE_DEPRECIATION,
  UPDATE_DEPRECIATION_SUCCESS,
  UPDATE_DEPRECIATION_FAIL,
  ADD_NEW_DEPRECIATION,
  ADD_DEPRECIATION_SUCCESS,
  ADD_DEPRECIATION_FAIL,
  DEPRECIATION_LOADING,
  DEPRECIATION_RESET,
  DEPRECIATION_RESET_CREATE
} from "./actionType";

export const resetDepreciationState = (actionType) => ({
  type: DEPRECIATION_RESET,
  payload: { actionType },
});


export const resetDepreciationCreateState = (actionType) => ({
  type: DEPRECIATION_RESET_CREATE,
  payload: { actionType }
});

export const getDepreciationSuccess = (actionType, data) => ({
  type: GET_DEPRECIATION_SUCCESS,
  payload: { actionType, data },
});

export const getDepreciationFail = (actionType, error) => ({
  type: GET_DEPRECIATION_FAIL,
  payload: { actionType, error },
});

export const getDepreciation = data => ({
  type: GET_DEPRECIATION,
  payload: data,
});

export const getDepreciationLoading = () => ({
  type: DEPRECIATION_LOADING
});

export const deleteDepreciation = data => ({
  type: DELETE_DEPRECIATION,
  payload: data,
});

export const deleteDepreciationSuccess = data => ({
  type: DELETE_DEPRECIATION_SUCCESS,
  payload: data,
});

export const deleteDepreciationFail = error => ({
  type: DELETE_DEPRECIATION_FAIL,
  payload: error,
});

export const updateDepreciation = data => ({
  type: UPDATE_DEPRECIATION,
  payload: data,
});

export const updateDepreciationFail = error => ({
  type: UPDATE_DEPRECIATION_FAIL,
  payload: error,
});

export const updateDepreciationSuccess = data => ({
  type: UPDATE_DEPRECIATION_SUCCESS,
  payload: data,
});

export const addNewDepreciation = data => ({
  type: ADD_NEW_DEPRECIATION,
  payload: data,
});

export const addDepreciationSuccess = data => ({
  type: ADD_DEPRECIATION_SUCCESS,
  payload: data,
});

export const addDepreciationFail = error => ({
  type: ADD_DEPRECIATION_FAIL,
  payload: error,
});